// ⚠️ Placeholder testimonials — replace with real client quotes before going live
const testimonials = [
  {
    quote: 'Our footfall doubled within 3 months. The Meta ads AerialRoot ran for us reached exactly the customers we wanted — no wasted budget.',
    name: 'Client Name',
    role: 'Owner, Restaurant Brand · Trichy',
    initials: 'CN',
    rating: 5,
  },
  {
    quote: 'They rebuilt our website and set up WhatsApp automation. Leads now come in every day and we respond instantly, even after hours.',
    name: 'Client Name',
    role: 'Founder, Retail Business · Chennai',
    initials: 'CN',
    rating: 5,
  },
  {
    quote: 'What impressed us most is the transparency. Every rupee spent is tracked in a dashboard, and the monthly reports are crystal clear.',
    name: 'Client Name',
    role: 'Director, Education Institute · Madurai',
    initials: 'CN',
    rating: 5,
  },
  {
    quote: 'From logo to full website in under two weeks. The team actually listened to what we wanted instead of pushing a template.',
    name: 'Client Name',
    role: 'Founder, Fashion Boutique · Trichy',
    initials: 'CN',
    rating: 5,
  },
  {
    quote: 'Our Google ranking moved from page 3 to the top 5 results for our main keywords within two months of the SEO work starting.',
    name: 'Client Name',
    role: 'Owner, Home Services Business · Coimbatore',
    initials: 'CN',
    rating: 5,
  },
  {
    quote: 'AerialRoot handles our entire social media calendar now. Engagement is up, and we finally have time to focus on the actual business.',
    name: 'Client Name',
    role: 'Co-founder, Cafe Chain · Trichy',
    initials: 'CN',
    rating: 5,
  },
];

export default testimonials;
